// mutations
export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL'
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR'
export const AJAX_CALL_SUCCESS = 'AJAX_CALL_SUCCESS'



// WEBPACK FOOTER //
// ./src/app/config/store/modules/ajax/types.js